<template>
  <Card :footer-divider="false" :title="$t('callCenterTile.title')">
    <template #content>
      <small class="mb-16" v-dompurify-html="$t('callCenterTile.text')"></small>
      <Alert type="default">
        <template v-slot:main>
          <div>
            <strong style="font-weight: bold">{{ $t('callCenterAlert.title') }}</strong>
            <span v-dompurify-html="$t('callCenterAlert.text')"></span>
          </div>
        </template>
      </Alert>
    </template>
    <template #footer>
      <div class="footer-cta footer-cta--left">
        <CustomButton @click="openKfzLandingPage" :buttonColor="ButtonColor.PRIMARY">
          {{ $t('callCenterTile.buttonLabel') }}
        </CustomButton>
        <CustomButton @click="goBack" class="button-back" :buttonColor="ButtonColor.LINK">
          {{ $t('callCenterTile.back') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import { Alert, ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'

const kfzLandingPageLink =
  globalThis.ENV_CONFIG?.REDIRECTS?.KFZ_LANDINGPAGE ??
  'https://www.da-direkt.de/autoversicherung'

function goBack(): void {
  globalThis.history.back()
}

function openKfzLandingPage() {
  globalThis.open(kfzLandingPageLink, '_blank')
}
</script>

<style lang="scss" scoped>
.button-back {
  @media (max-width: 426px) {
    margin-right: auto;
  }
}
</style>
